const selfreferrals = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Self Referrals",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "px-4 pt-4",
        children: [
          {
            title: "Groups",
            service: "categoryGroups",
            type: "",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: true,
              deleteButton: true,
              addNewSuccessTitle: "Group Added!",
              addNewSuccessMessage: "Group Added Successfully!",
              addNewErrorTitle: "Group Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Group Deleted!",
              deleteSuccessMessage: "Group Deleted Successfully!",
              deleteErrorTitle: "Group Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Group Activated!",
              activeSuccessMessage: "Group Activated Successfully!",
              activeErrorTitle: "Group Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Group Updated!",
              updateSuccessMessage: "Group Updated Successfully!",
              updateErrorTitle: "Group Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Group",
                variant: "add",
                form: {
                  title: {
                    type: "text",
                    label: "Group Name",
                    placeholder: "Enter Group Name",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                  text: {
                    type: "ckeditor",
                    label: "Description",
                    placeholder: "Enter Description",
                    required: false,
                    info: true,
                    character_count: 1000,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  active: true,
                  // "subgroups": [],
                },
              },
            },
            children: [
              {
                type: "clinicServicesGroupsTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Group",
                  type: "groupList",
                  info: true,
                  size: "4",
                  style: "",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  form: {
                    title: {
                      type: "text",
                      label: "Group Name",
                      placeholder: "Enter Group Name",
                      required: true,
                      info: true,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    text: {
                      type: "ckeditor",
                      label: "Description",
                      placeholder: "Enter Description",
                      required: false,
                      info: true,
                      character_count: 1000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    id: {
                      type: "slug",
                      label: "Path",
                      url: "/referrals/$slug",
                      placeholder: "Enter Path / Slug",
                      required: false,
                      info: true,
                      character_count: 50,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "Services",
            service: "pages",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: true,
              deleteButton: true,
              addNewSuccessTitle: "Service Added!",
              addNewSuccessMessage: "Service Added Successfully!",
              addNewErrorTitle: "Service Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Service Deleted!",
              deleteSuccessMessage: "Service Deleted Successfully!",
              deleteErrorTitle: "Service Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Service Activated!",
              activeSuccessMessage: "Service Activated Successfully!",
              activeErrorTitle: "Service Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Service Updated!",
              updateSuccessMessage: "Service Updated Successfully!",
              updateErrorTitle: "Service Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Service",
                submit_url: "/api/categories/$currentCategoryId/pages",
                variant: "add",
                form: {
                  title: {
                    type: "text",
                    label: "Service Title",
                    placeholder: "Enter Service Title",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  group: "",
                },
              },
            },
            children: [
              {
                type: "clinicsAndServicesTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Select a Topic",
                  type: "list",
                  info: true,
                  size: "4",
                  style:
                    "border-right: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  form: {
                    title: {
                      type: "text",
                      label: "Title",
                      placeholder: "Enter Title",
                      required: true,
                      info: true,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    group: {
                      type: "groupSelectClinics",
                      label: "Group",
                      placeholder: "Select Group",
                      inside: ["additionalProp1", "group"],
                      load_url: "",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    url: {
                      type: "slug",
                      label: "Path",
                      url: "/selfreferrals/$groupId/$slug",
                      placeholder: "Enter Path / Slug",
                      required: false,
                      info: true,
                      character_count: 50,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    description: {
                      type: "ckeditor",
                      label: "Description",
                      placeholder: "Enter Description",
                      required: false,
                      info: true,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "Settings",
            service: "category",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: false,
              deleteButton: false,
              updateSuccessTitle: "Category Updated!",
              updateSuccessMessage: "Category Updated Successfully!",
              updateErrorTitle: "Category Updation Failed!",
              updateErrorMessage: "Please try again!",
            },
            children: [
              {
                type: "descriptionTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  type: "list",
                  size: "4",
                  style: "",
                  class: "p-2",
                  empty: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  form: {
                    title: {
                      type: "text",
                      label: "Title",
                      placeholder: "Enter Title",
                      required: true,
                      info: true,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    text: {
                      type: "ckeditor",
                      label: "Description",
                      placeholder: "Enter Description",
                      required: false,
                      info: true,
                      character_count: 1000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr1: {
                      type: "hr",
                      size: "12",
                    },
                    expanded: {
                      type: "toggle",
                      label: "Expanded Tiles",
                      placeholder: "Expanded Tiles",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr2: {
                      type: "hr",
                      size: "12",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { selfreferrals };
